import React from "react";
import { createHashRouter, RouterProvider } from "react-router-dom";
import Root from "../routes/Root";
import Error from "../routes/Error";
import Loader from "../routes/Loader";
import Login from "../routes/Login";
import Posts from "../routes/Posts";
import Tags from "../routes/Tags";
import Sections from "../routes/Sections";
import Users from "../routes/Users";
import Profile from "../routes/Profile";
import Post from "../routes/Post";


const router = createHashRouter([
  {
    path: "/login",
    element: <Login />,
    loader: () => <Loader />,
    errorElement: <Error />,
  },
  {
    path: "/",
    element: <Root />,
    loader: () => <Loader />,
    errorElement: <Error />,
    children: [
      {
        path: "/",
        element: <Posts />
      },
      {
        path: "tags",
        element: <Tags />
      },
      {
        path: "sections",
        element: <Sections />
      },
      {
        path: "users",
        element: <Users />
      },
      {
        path: "profile",
        element: <Profile />
      },
      {
        path: "new-post",
        element: <Post />
      },
      {
        path: "edit-post/:id",
        element: <Post />
      }
    ]
  }
]);

export default function App() {
  return <RouterProvider router={router} />;
}
